import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input"]

  update(event) {
    event.preventDefault()
    const active = event.target.dataset.active
    this.inputTarget.value = active
    this.formTarget.requestSubmit()
  }
} 